import React from 'react';
import { Col, Row } from 'react-bootstrap';

/**
 * @component QuestionPassage
 * @description
 * Componente encargado de mostrar un pasaje o texto complementario asociado a una pregunta.
 * Generalmente se usa para dar contexto o información adicional antes de responder.
 *
 * Si no se recibe un `passage`, el componente no renderiza nada.
 *
 * @param {Object} props
 * @param {string} props.passage - Texto del pasaje que se mostrará como bloque de lectura
 *
 * @returns {JSX.Element|null} Renderiza un bloque de texto o `null` si no hay pasaje
 *
 * @example
 * <QuestionPassage passage="Read the following paragraph and answer the questions." />
 */
const QuestionPassage = ({ passage }) => {
	if (!passage) return null;

	return (
		<Row className="mt-3 justify-content-center">
			<Col xl={8}>
				<div className="border p-3 rounded bg-light" style={{ whiteSpace: 'pre-line' }}>
					{passage}
				</div>
			</Col>
		</Row>
	);
};

export default QuestionPassage;